import React, { Component } from 'react';

import Jumbotron from 'react-bootstrap/Jumbotron'
import Footer from './task/Footer'

import './NoticeApp.css';


class NoticeApp extends Component {
  render() {
    return <div className='NoticeApp'>
      <Jumbotron>
        <h1>Cloze Testアプリ利用上の注意</h1>
        <div className='DashboardLogin'>
          Cloze Testアプリは東京大学 開研究室にて開発している英語学習アプリです。
        </div>
      </Jumbotron>
      <h2>対応ブラウザ</h2>
      <p>
        本アプリケーションは PC版Chrome, Firefox, Safari 及び iOS版Safari, Android版Chrome で動作確認しています。
      </p>
      <Footer />
    </div>
  }
}

export default NoticeApp;
